import React from 'react';
import BzDropdownButton, { DropdownButtonItem } from 'components/buttons/BzDropdownButton';

interface BzUrlDropDownProps {
  isReadOnly?: boolean;
  method: string;
  updateState: (field: string, value: any, ignoreDirty?: boolean) => void;
}

const HttpMethodDropdown = (props: BzUrlDropDownProps) => {
  type MethodStyle = [string, string];

  const urlButtonMethods: MethodStyle[] = [
    ['GET', 'btn-method-get'],
    ['POST', 'btn-method-post'],
    ['PUT', 'btn-method-put'],
    ['DELETE', 'btn-method-delete'],
    ['PATCH', 'btn-method-patch'],
    ['OPTIONS', 'btn-method-options'],
    ['TRACE', 'btn-method-trace'],
    ['HEAD', 'btn-method-head'],
    ['CONNECT', 'btn-secondary'],
    ['ANY', 'btn-secondary'],
  ];

  const urlButtonItems: DropdownButtonItem[] = urlButtonMethods.map((m: MethodStyle) => ({
    key: m[0],
    title: m[0],
    extraCls: m[1],
  }));

  const selectedUrlButton = urlButtonItems.find(i => i.key === props.method) as DropdownButtonItem;

  return (
    <BzDropdownButton
      disabled={props.isReadOnly}
      variant="primary"
      className="input-group-prepend"
      id="url-method"
      width="100px"
      dropdownItems={urlButtonItems}
      selectedItem={selectedUrlButton ? selectedUrlButton : urlButtonItems[0]}
      center={true}
      onSelectedItem={(item: DropdownButtonItem) => props.updateState('method', item.key)}
    />
  );
};

export default HttpMethodDropdown;
